module.exports = __webpack_public_path__ + "static/img_2191-51ea0729cf0ba6fd7d2fefab85d73dd1.webp";